'use client';
import React from 'react';
import { ToastDuration } from '@/util/const';
import { Toaster, toast } from 'react-hot-toast';
import {
  MdOutlineErrorOutline,
  MdWarningAmber,
  MdCheck,
  MdOutlineClear,
} from 'react-icons/md';
import useWidth from '@/util/useWidth';
import Button from '../atoms/Button';
export function showToast(type: 'error' | 'success', msg?: string) {
  console.log('showToast', type, msg);
  const f = type == 'error' ? toast.error : toast.success;
  f((t) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5em',
      }}
    >
      {msg || 'エラーが発生しました'}
      <Button
        label={<MdOutlineClear />}
        theme="icon-white"
        onClick={() => {
          toast.dismiss(t.id);
        }}
      ></Button>
    </div>
  ));
}

export default function ToasterCommon() {
  const { isMobile } = useWidth();
  return (
    <>
      <Toaster
        position="bottom-right"
        reverseOrder
        gutter={30}
        containerStyle={{
          margin: isMobile ? '64px 0' : 'inherit',
        }}
        toastOptions={{
          duration: ToastDuration,
          style: {
            borderRadius: 0,
            fontFamily: 'Noto Sans JP',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '28px',
            letterSpacing: '0.04em',
          },
          error: {
            style: {
              backgroundColor: 'var(--error-main, #f43f5e)',
              color: 'white',
              borderRadius: '4px',
            },
            icon: <MdOutlineErrorOutline />,
            iconTheme: {
              primary: 'white',
              secondary: 'white',
            },
          },
          success: {
            style: {
              backgroundColor: 'var(--success-main, #22c55e)',
              color: 'white',
              borderRadius: '4px',
            },
            icon: <MdCheck />,
            iconTheme: {
              primary: 'white',
              secondary: 'white',
            },
          },
          loading: {
            //loadingは青色です
            style: {
              backgroundColor: 'var(--info-main, #3b82f6)',
              color: 'white',
              borderRadius: '4px',
            },
          },
          custom: {
            //customはcaution用です
            style: {
              backgroundColor: 'var(--caution-main, #f59e0b)',
              color: 'white',
              borderRadius: '4px',
            },
            icon: <MdWarningAmber />,
            iconTheme: {
              primary: 'white',
              secondary: 'white',
            },
          },
        }}
      />
    </>
  );
}
